import React, { createContext, useEffect, useState } from "react";

import { PropsType } from "../../interfaces/ChildrenType";

import { Customer } from "../../interfaces/Customer";

import { CustomerContextType } from "./customer-context.types";
//console.log("session Strorage",sessionStorage.getItem("CEX-Customer"))
const customerData = sessionStorage.getItem("CEX-Customer");

const initialState: CustomerContextType = {
  customer: JSON.parse(customerData as string) || null,

  setCustomer: () => {},
};

export const CustomerContext = createContext(initialState);

export const CustomerContextProvider: React.FC<PropsType> = ({ children }) => {
  const [customer, setCustomer] = useState<Customer | null>(
    initialState.customer
  );

  useEffect(() => {
    if (customer) {
      sessionStorage.setItem("CEX-Customer", JSON.stringify(customer));
    } else {
      sessionStorage.removeItem("CEX-Customer");
    }
  }, [customer]);

  return (
    <CustomerContext.Provider value={{ customer, setCustomer }}>
      {children}
    </CustomerContext.Provider>
  );
};
